<script>
import { isDefined } from '../../utils/utils'
import formMixin from '../../mixin/formMixin'
export default {
  name: 'AnsoDescriptions',
  mixins: [formMixin],
  props: {
    form: {
      required: false,
      type: Object,
      default: () => ({}),
    },
    formList: {
      type: Array,
      default: () => [],
    },
    formField: {
      // 作为form表单子项时，需要传入父级pform的key 对应父级form的field
      required: false,
      type: String,
      default: '',
    },
    modelType: {
      // 支持三种类型add\edit\detail
      require: false,
      type: String,
      default: () => {
        return 'add'
      },
    },
    direction: {
      type: String,
      default: 'horizontal', // vertical / horizontal
    },
    border: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'small', // medium / small / mini
    },
    column: {
      type: Number,
      default: 3,
    },
    title: {
      type: String,
      default: '',
    },
    extra: {
      type: [String, Function],
      default: '',
    },
    colon: {
      type: Boolean,
      default: true,
    },
    labelClassName: {
      type: String,
      default: '',
    },
    contentClassName: {
      type: String,
      default: '',
    },
    labelStyle: {
      type: Object,
      default: () => ({}),
    },
    contentStyle: {
      type: Object,
      default: () => ({}),
    },
    rules: {
      type: Object,
      default: () => ({}),
    },
    isFormModel: {
      // 是否开启form模式
      required: false,
      type: Boolean,
      default: false,
    },
    isFormChildItem: {
      // 是否作为form表单子项
      required: false,
      type: Boolean,
      default: false,
    },
    isShowExpandBtn: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.formList.forEach((item) => {
      if (
        item.type === 'title' ||
        item.type === 'divider' ||
        item.type === 'subTitle'
      ) {
        this.$set(item, 'notFormItem', true)
      }
      if (isDefined(item['field'])) {
        // 新增模式下初始化表单字段
        if (this.modelType === 'add') {
          if (
            item.type === 'checkbox' ||
            (item.type === 'select' && item.multiple)
          ) {
            this.$set(
              this.formField ? this.form[this.formField] : this.form,
              item['field'],
              Array.isArray(item['value']) ? item['value'] : []
            )
          } else if (item.type === 'mixinInput') {
            this.$set(
              this.formField ? this.form[this.formField] : this.form,
              item['field'],
              item['value'] || {}
            )
          } else {
            this.$set(
              this.formField ? this.form[this.formField] : this.form,
              item['field'],
              item['value'] || ''
            )
          }
        }
      }
    })
    console.log(
      this.form,
      this.formField,
      this.isFormChildItem,
      '============descriptions form=============='
    )
  },
  data() {
    return {
      expand: true,
    }
  },
  methods: {
    generateForm() {
      let { rules } = this
      return (
        <el-form props={{ model: this.form }} rules={rules}>
          {this.generateDescriptions()}
        </el-form>
      )
    },
    generateDescriptionsItemLabel(item) {
      let { label } = item
      return <span>{label}</span>
    },
    generateFormItem(item) {
      let { field, label, rules } = item
      let form = this.formField ? this.form[this.formField] : this.form
      return (
        <el-form-item
          rules={rules}
          prop={this.formField ? `${this.formField}.${field}` : field}
        >
          {this.generateFormItemChild(item, form)}
        </el-form-item>
      )
    },
    generateDescriptionsItem() {
      if (!this.expand) {
        return
      }
      let form = this.formField ? this.form[this.formField] : this.form
      let { formList } = this
      return formList.map((item) => {
        let { span, label, notFormItem } = item
        notFormItem === undefined && (notFormItem = true)
        if (this.isFormChildItem || this.isFormModel) {
          notFormItem = false
        }
        return (
          <el-descriptions-item
            props={{
              span,
              label,
            }}
          >
            <template slot="label">
              {this.generateDescriptionsItemLabel(item)}
            </template>
            <template>
              {notFormItem
                ? this.generateFormItemChild(item, form)
                : this.generateFormItem(item)}
            </template>
          </el-descriptions-item>
        )
      })
    },
    generateDescriptions() {
      let {
        title,
        column,
        direction,
        size,
        border,
        colon,
        labelClassName,
        contentClassName,
        labelStyle,
        contentStyle,
      } = this
      return (
        <el-descriptions
          ref="elDescriptions"
          class="descriptions-list"
          props={{
            title,
            column,
            direction,
            size,
            border,
            colon,
            labelClassName,
            contentClassName,
            labelStyle,
            contentStyle,
          }}
        >
          {this.generateDescriptionsItem()}
          <template slot="extra">
            <div class="descriptions-extra">
              <div class="extra-content">
                {typeof this.extra === 'function' ? this.extra() : this.extra}
              </div>
              {this.generateExpandBtn()}
            </div>
          </template>
        </el-descriptions>
      )
    },
    generateExpandBtn() {
      if (!this.isShowExpandBtn) {
        return
      }
      return (
        <el-button
          type="text"
          class="expand-btn"
          size="small"
          onClick={() => {
            this.expand = !this.expand
          }}
        >
          {this.expand ? '收起' : '展开'}
          <i
            class={[
              this.expand ? 'el-icon-arrow-up' : 'el-icon-arrow-down',
              'expand-icon',
            ]}
          ></i>
        </el-button>
      )
    },
  },
  render() {
    return (
      <div>
        {this.isFormModel ? this.generateForm() : this.generateDescriptions()}
      </div>
    )
  },
}
</script>
<style lang="scss" scoped>
.descriptions-list {
  ::v-deep {
    .el-descriptions__header {
      margin-bottom: 10px;
    }

    .el-descriptions-row {
      .el-descriptions-item__cell {
        padding: 4px 5px;

        .el-divider {
          margin: 10px 0;
        }
        .subTitle,
        .title {
          height: 34px;
          line-height: 34px;
        }
      }

      .el-select,
      .el-date-editor,
      .el-cascader {
        width: 100%;
      }

      .el-form-item {
        margin-bottom: 0px;

        .el-form-item__content {
          line-height: 100%;
          .el-form-item__error {
            position: relative;
          }
        }
      }
    }
  }

  .descriptions-extra {
    display: flex;
    align-items: center;
    .extra-content {
      flex: 1;
    }
    .expand-btn {
      margin-left: 10px;
      width: max-content;
      display: flex;
      align-items: center;
      cursor: pointer;

      i {
        margin-left: 5px;
      }
    }
  }
}
</style>
